export default __webpack_public_path__ + "static/media/Mostafa Tarek_Aioup_CV.30af61f2.pdf";